var exports = {
  "W": "xe564cbfb--4f1349--labels",
  "s": "xe564cbfb--4f1349--promo",
};

module.exports = exports;
